import React, { useEffect } from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { Space } from 'antd';

import './stack-screen.scss';

export interface StackScreenProps {
  title: React.ReactNode | string;
  isOpen?: boolean;
  renderHeader: React.ReactNode;
  onClose: () => void;
}

export const StackScreen: React.FC<StackScreenProps> = ({
  children,
  title,
  isOpen,
  renderHeader,
  onClose,
}) => {
  useEffect(() => {
    if (isOpen)
      document.body.classList.add('stack-screen--open');
    else
      document.body.classList.remove('stack-screen--open');
  }, [])

  if (!isOpen) return null;

  return (
    <React.Fragment>
      <div className="stack-screen">
        <div className="stack-screen-header">
          <div className="stack-screen-header--inner">
            <Space className="header--body" direction="horizontal" size="large">
              <div className="title">
                {title}
              </div>
              <div className="stack-screen-header--body-right">
                {renderHeader}
              </div>
            </Space>
            <div className="btn-close-x" onClick={onClose}>
              <CloseOutlined />
            </div>
          </div>
        </div>

        <main className="stack-screen-content">
          <div className="stack-screen-content--body">
            {children}
          </div>
        </main>
      </div>

      <div className="stack-screen--mask" />
    </React.Fragment>
  )
}
